import React from 'react'
import './unit-tests-section.scss'
import UnitTestsTable from './unit-tests-table/UnitTestsTable'
import ReferenceSolution from './unit-tests-table/ReferenceSolution'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { connect } from 'react-redux'

const UnitTestsSection = ({ assignment }) => {
    useDocumentTitle(`${assignment.assignment_name || ''} Unit tests`)

    return (
        <div>
            <UnitTestsTable />
            <ReferenceSolution />
        </div>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
    }
}

export default connect(mapState, null)(UnitTestsSection)
